import { render, staticRenderFns } from "./DrawBtn.vue?vue&type=template&id=734df5ae&scoped=true"
import script from "./DrawBtn.vue?vue&type=script&lang=js"
export * from "./DrawBtn.vue?vue&type=script&lang=js"
import style0 from "./DrawBtn.vue?vue&type=style&index=0&id=734df5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734df5ae",
  null
  
)

export default component.exports